/**
 * Null EDIABAS Provider - no-op implementation for testing
 */
import { EventEmitter } from 'eventemitter3';
export class NullEdiabasProvider extends EventEmitter {
    async init() { }
    async end() { }
    async job(_ecu, _job, _arg1, _arg2) {
        this.emit('job:complete', { ecu: _ecu, job: _job, sets: 0 });
    }
    resultSets() {
        return 0;
    }
    resultText(_result, _set, _format) {
        return '';
    }
    resultInt(_result, _set) {
        return 0;
    }
    resultDigital(_result, _set) {
        return false;
    }
    resultAnalog(_result, _set) {
        return 0;
    }
    resultBinary(_result, _set) {
        return new Uint8Array(0);
    }
    hasResult(_result, _set) {
        return false;
    }
    checkJobStatus(_refStr) {
        return true;
    }
    isBusy() {
        return false;
    }
    async fsLesen(_ecu, _fileName) { }
    async fsLesen2(_ecu, _fileName) { }
    fsMode(_mode, _fileMode, _preInfoFile, _postInfoFile, _jobName) { }
    getFsModeConfig() {
        return { mode: 0, fileMode: '', preInfoFile: '', postInfoFile: '', jobName: 'FS_LESEN' };
    }
}
//# sourceMappingURL=ediabas.js.map